import React, { useState } from 'react';
import { ArrowUpRight, Menu, X } from 'lucide-react';
import Logo from '../Logo';

export default function LandingNavigation({ onLogin, onRegister, navigateTo, onHome, productTarget = '#product' }) {
  const [open, setOpen] = useState(false);
  const links = [['Product', productTarget], ['Solutions', '/solutions'], ['Pricing', '/pricing'], ['Guides', '/guides']];
  const visit = (target) => {
    setOpen(false);
    if (target.startsWith('#')) {
      // Wait for the mobile menu to close before measuring the anchor position.
      requestAnimationFrame(() => document.getElementById(target.slice(1))?.scrollIntoView({ behavior: 'smooth' }));
    }
    else navigateTo(target);
  };
  return (
    <header className="sticky top-0 z-40 border-b border-slate-200/80 bg-white/95 backdrop-blur-lg">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between gap-4 px-5 sm:px-8">
        <button aria-label="Lexa.run home" onClick={onHome || (() => navigateTo('/'))}><Logo size="md" /></button>
        <nav aria-label="Main navigation" className="hidden items-center gap-7 text-sm font-medium text-slate-600 lg:flex">
          {links.map(([label, target]) => <button key={label} onClick={() => visit(target)} className="transition-colors hover:text-violet-700">{label}</button>)}
          <button onClick={() => navigateTo('/contact')} className="hover:text-violet-700">Contact</button>
        </nav>
        <div className="hidden items-center gap-6 sm:flex">
          <button onClick={onLogin} className="text-sm font-semibold text-slate-700 hover:text-violet-700">Sign in</button>
          <button onClick={onRegister} className="inline-flex items-center gap-3 rounded-full bg-slate-950 px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-violet-700">Get started free <ArrowUpRight size={16} />
          </button>
        </div>
        <button className="rounded-lg p-2 text-slate-800 lg:hidden" aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} aria-controls="landing-mobile-menu" onClick={() => setOpen(!open)}>
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <nav id="landing-mobile-menu" aria-label="Mobile navigation" className="space-y-1 border-t border-slate-100 bg-white px-5 py-4 lg:hidden">
          {links.map(([label, target]) => <button key={label} onClick={() => visit(target)} className="block w-full py-3 text-left text-sm font-medium text-slate-700">{label}</button>)}
          <button onClick={() => { setOpen(false); navigateTo('/contact'); }} className="block w-full py-3 text-left text-sm font-medium text-slate-700">Contact</button>
          <div className="flex gap-3 border-t border-slate-100 pt-4 sm:hidden">
            <button onClick={() => { setOpen(false); onLogin(); }} className="flex-1 rounded-full border border-slate-200 px-4 py-3 text-sm font-semibold">Sign in</button>
            <button onClick={() => { setOpen(false); onRegister(); }} className="flex-1 rounded-full bg-violet-700 px-4 py-3 text-sm font-semibold text-white">Get started free</button>
          </div>
        </nav>
      )}
    </header>
  );
}
